import type { ReactNode } from 'react'

import { IntentionForm } from '@/src/features/intention/ui/components/IntentionForm'
import type { TSourceParam } from '@/src/general/constants/routes'
import { useTrackDisplayed } from '@/src/general/hooks/useTrackOnce'
import { GTM } from '@/src/general/utils/gtm'
import { EVENTS } from '@/src/general/utils/gtm/constants'

type TPublicationRewardIntentionFormProps = TSourceParam & {
  publicationId: number
}

export const PublicationRewardIntentionForm = ({
  source,
  publicationId,
}: TPublicationRewardIntentionFormProps): ReactNode => {
  useTrackDisplayed(EVENTS.POST_PRAY_PUBLICATION_POST_INTENTION_DISPLAYED, publicationId, { trackingSource: source })

  return <IntentionForm onSubmit={() => GTM.sendEvent(EVENTS.POST_PRAY_PUBLICATION_POST_INTENTION_CLICKED)} />
}
